import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './InfectionPC.css';
const cx = classNames.bind(styles);

class InfectionPC extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { pcCount, leakCount, leakSize, size, noTooltip } = this.props;

    return (
      <Tooltip
        title={
          noTooltip
            ? ''
            : defineMessages(formatMessage({ id: 'ExamListItem_7', defaultMessage: '감염 PC' })) +
              ': ' +
              (!!pcCount
                ? pcCount +
                  defineMessages(formatMessage({ id: 'ExamListItem_8', defaultMessage: '대' })) +
                  ' ' +
                  leakCount +
                  ' (' +
                  leakSize +
                  ')'
                : defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' })))
        }
        placement="bottom">
        <div
          className={cx(
            'pcMain-set',
            // 감염 PC 없음
            { safe: pcCount === 0 },
            // 감염 PC가 4자리 수
            { wide: pcCount > 999 },
            // 사이즈
            { large: size && size === 'l' },
            { small: size && size === 's' }
          )}>
          <span className={cx('pcMain-title')}>
            {/* <Icon name="laptop" /> */}
            <Image src={pcCount > 0 ? '/img/exam/list_pc_red.png' : '/img/exam/list_pc_grey.png'} />
          </span>
          <span className={cx('pcMain-count')}>
            {!!pcCount
              ? pcCount + defineMessages(formatMessage({ id: 'ExamListItem_8', defaultMessage: '대' }))
              : defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' }))}
          </span>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(InfectionPC);



// WEBPACK FOOTER //
// ./src/script/components/common/InfectionPC.js